import React from 'react'
import GenericModal from "../../../../components/modal/GenericModal";

const ConfirmarGuardar = ({ toggleModal, submit, children }) => {

  const submitLocal = async () => {
    toggleModal();
    await submit();
  };

  return (
    <GenericModal
      titulo="Confirmar"
      showModal={toggleModal}
      width={"600px"}
    >
      <div className="modal-body pt-0 pl-0">

        {children}
      </div>
      <div className="modal-footer justify-content-end pb-0">
        <button
          className="btn btn-primary generic-button-ficha mr-2"
          onClick={submitLocal}>
          Guardar
        </button>
        <button
          className="btn btn-primary generic-button-ficha"
          onClick={() => { toggleModal() }}>
          Cancelar
        </button>
      </div>
    </GenericModal>
  )
}

export default ConfirmarGuardar